import { AssetCategory } from '@/shared/lib/sj-orm';
import { DtoId } from '@/shared/lib/sj-orm/models/base.dto';

export const routes = {
  assets: () => '/assets',
  asset: (id: DtoId) => `/assets/${id}`,
  assetEdit: (id: DtoId) => `/assets/edit/${id}`,
  assetCreate: (category: AssetCategory) => `/assets/create/${category}`,
  beneficiaries: () => '/beneficiaries',
  beneficiary: (id: DtoId) => `/beneficiaries/${id}`,
  personalIds: () => '/personal-identifiers',
  personalId: (id: DtoId) => `/personal-identifiers/${id}`,
  personalIdCreate: (category?: string) =>
    category ? `/personal-identifiers/create/${category}` : '/personal-identifiers/create',
  personalIdEdit: (id: DtoId) => `/personal-identifiers/edit/${id}`,
  privateDocuments: () => '/private-documents',
  privateDocument: (id: DtoId) => `/private-documents/${id}`,
  privateDocumentCreate: (category: string) => `/private-documents/create/${category}`,
  privateDocumentEdit: (id: DtoId) => `/private-documents/edit/${id}`,
  contacts: () => '/contacts',
  contact: (id: DtoId) => `/contacts/${id}`,
};
